import { readAfterInitialTaskSync } from './initialTaskSync';
import type { Task } from '../types';
import { apiRequest } from './api';
import { captureSessionEpoch, isSessionEpochCurrent } from './sessionEpoch';

export interface TaskPage { items: Task[]; nextCursor: string | null }
export interface TaskFilters {q?:string;styleNumber?:string;fabricNumber?:string;project?:string;customer?:string;batchName?:string;workspace?:string;status?:string;order?:'newest'|'oldest';expiry?:'soon'|'expired'|'permanent'}
export function decodeTaskSummary(item: Omit<Task, 'inputs' | 'promptText'>): Task {
  // Neutral compatibility fields are never presented as task detail: summary
  // records are marked and the detail modal obtains an authenticated full record.
  return { ...item, inputs: [], promptText: '', detailState: 'summary' };
}
export async function requestTaskPage(kind: 'tasks' | 'results', limit: number, cursor?: string | null, filters:TaskFilters={}): Promise<TaskPage> {
  const query = new URLSearchParams({ limit: String(limit) });
  if (cursor) query.set('cursor', cursor);
  for(const [key,value] of Object.entries(filters))if(value)query.set(key,value);
  const page = await readAfterInitialTaskSync(() => apiRequest<TaskPage>(`/api/${kind}/page?${query}`));
  return { ...page, items: page.items.map(decodeTaskSummary) };
}

/** Rebuild the loaded prefix after invalidation; never append stale pages to a new first page. */
export async function requestTaskPrefix(kind: 'tasks' | 'results', count: number, pageSize: number,filters:TaskFilters={}): Promise<TaskPage> {
  const epoch = captureSessionEpoch();
  const items: Task[] = [];
  let nextCursor: string | null = null;
  const cursors = new Set<string>();
  do {
    const page = await requestTaskPage(kind, Math.min(pageSize, count - items.length), nextCursor,filters);
    if (!isSessionEpochCurrent(epoch)) throw new Error('账号已切换');
    items.push(...page.items);
    nextCursor = page.nextCursor;
    if (nextCursor && (cursors.has(nextCursor) || !page.items.length)) throw new Error('分页响应异常，请刷新重试');
    if (nextCursor) cursors.add(nextCursor);
  } while (nextCursor && items.length < count);
  return { items, nextCursor };
}
